<template>
    <div class="bot-manager">
        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">

                <!-- <el-form-item label="积分类型">
                    <el-select v-model="searchForm.ruleType" placeholder="请选择积分类型" clearable size="large"
                        style="width: 200px">
                        <el-option label="所有类型" value="" />
                        <el-option label="手动增加" value="add" />
                        <el-option label="手动减少" value="sub" />
                        <el-option label="邀请" value="invite" />
                        <el-option label="签到" value="sign" />
                        <el-option label="文字信息" value="textContent" />
                        <el-option label="图片信息" value="photoContent" />
                        <el-option label="视频信息" value="videoContent" />
                        <el-option label="贴纸信息" value="stickerContent" />
                        <el-option label="兑换" value="redeem" />
                        <el-option label="骰子游戏" value="gameDice" />
                    </el-select>


                </el-form-item> -->

                <el-form-item label="积分类型">
                    <el-select v-model="searchForm.ruleType" placeholder="请选择积分类型" clearable size="large"
                        style="width: 200px">
                        <el-option label="所有类型" value="" />
                        <el-option v-for="(label, value) in ruleTypeMap" :key="value" :label="label" :value="value" />
                    </el-select>
                </el-form-item>




                <el-form-item>
                    <div class="button-group">
                        <el-button type="primary" @click="onSearch" size="large">
                            <el-icon>
                                <Search />
                            </el-icon>搜索
                        </el-button>
                        <el-button @click="resetSearch" size="large">
                            <el-icon>
                                <Refresh />
                            </el-icon>重置
                        </el-button>

                    </div>
                </el-form-item>
            </el-form>
        </div>
        <el-divider></el-divider>
        <el-table :data="tableData" style="width: 100%" v-loading="loading">
            <el-table-column prop="nickname" label="群成员" min-width="500">
                <template #default="scope">
                    {{ scope.row.nickname }} [{{ scope.row.userId }}]
                </template>
            </el-table-column>

            <el-table-column prop="pointNum" label="积分变化" min-width="100" />
            <!-- <el-table-column prop="ruleType" label="积分类型" min-width="100" /> -->

            <el-table-column prop="ruleType" label="积分类型" min-width="100">
                <template #default="scope">
                    {{ ruleTypeMap[scope.row.ruleType] || scope.row.ruleType }}
                </template>
            </el-table-column>

            <el-table-column prop="userPoint" label="积分余额" min-width="100" />
            <el-table-column prop="createTime" label="积分时间" min-width="180">
                <template #default="scope">{{ formatDateTime(scope.row.createTime) }}</template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { Search, Refresh } from '@element-plus/icons-vue'
import api from '@/services/api'

export default {
    name: 'PointHis',
    components: { Search, Refresh },
    data() {
        return {
            searchForm: { ruleType: '' },
            tableData: [],
            currentPage: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            currentUserInfo: {
                userid: null,
                groupid: null,
                userBot: null
            },
            ruleTypeMap: {
                add: '手动增加',
                sub: '手动减少',
                invite: '邀请',
                sign: '签到',
                textContent: '文字信息',
                photoContent: '图片信息',
                videoContent: '视频信息',
                stickerContent: '贴纸信息',
                redeem: '兑换',
                gameDice: '骰子游戏',
                gameDiceReturn: '骰子游戏返回',
                gameDiceWin: '骰子游戏中奖'
            }
        }
    },
    watch: {
        vuexUser: {
            handler(newUser) {
                if (newUser) {
                    this.loadUserInfo(newUser);
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        loadUserInfo(user) {
            this.currentUserInfo.userId = user.userId;
            this.currentUserInfo.groupId = user.groupId;
            this.currentUserInfo.userBot = user.userBot;
        },
        // 搜索功能
        onSearch() { this.currentPage = 1; this.fetchData(); },
        resetSearch() { this.searchForm = { ruleType: '' }; this.currentPage = 1; this.fetchData(); },
        // 获取数据
        async fetchData() {
            this.loading = true;
            try {
                const params = {
                    page: this.currentPage,
                    pageSize: this.pageSize,
                    groupid: this.currentUserInfo.groupId,
                };
                if (this.searchForm.ruleType) params.ruleType = this.searchForm.ruleType;
                const response = await api.getPointHis(params);
                if (response.data.code === 0) {
                    this.tableData = response.data.data.records;
                    this.total = response.data.data.total;
                } else {
                    this.$message.error(response.data.message || '获取数据失败');
                }
            } catch (error) {
                console.error('获取积分日志失败:', error);
                this.$message.error('获取数据失败');
            } finally {
                this.loading = false;
            }
        },
        handleSizeChange(val) { this.pageSize = val; this.currentPage = 1; this.fetchData(); },
        handleCurrentChange(val) { this.currentPage = val; this.fetchData(); },
        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            const date = new Date(dateTime);
            return date.toLocaleString('zh-CN');
        }
    },
    mounted() {
        // 
        if (this.$store.state.user) {
            this.loadUserInfo(this.$store.state.user);
            this.fetchData()
        }

    }
}
</script>

<style scoped>
.bot-manager {
    padding: 20px;
}

.search-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.button-group {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.pagination {
    margin-top: 20px;
    text-align: center;
}

.dialog-footer {
    text-align: right;
}

.el-divider {
    margin: 20px 0;
}
</style>